import { getEnv } from '../config/env';

/**
 * Inactivity Monitor Configuration Constants
 * Centralized configuration for user inactivity monitoring and auto-logout
 * Priority: .env → constant
 * Environment Variables:
 * - VITE_INACTIVITY_TIMEOUT_MINUTES: Minutes of inactivity before auto-logout
 * - VITE_INACTIVITY_CHECK_INTERVAL_SECONDS: How often to check for inactivity
 */

// Constants (can be modified here if needed)
const INACTIVITY_TIMEOUT_MINUTES = 120;
const INACTIVITY_CHECK_INTERVAL_SECONDS = 30;

export const INACTIVITY_CONFIG = {
    // Inactivity timeout in milliseconds
    // Priority: .env → constant 
    TIMEOUT_MS: parseInt(
        getEnv('VITE_INACTIVITY_TIMEOUT_MINUTES') ||
        INACTIVITY_TIMEOUT_MINUTES,
        10
    ) * 60 * 1000,
    
    // How often to check for inactivity in milliseconds
    // Priority: .env → constant
    CHECK_INTERVAL_MS: parseInt(
        getEnv('VITE_INACTIVITY_CHECK_INTERVAL_SECONDS') ||
        INACTIVITY_CHECK_INTERVAL_SECONDS,
        10
    ) * 1000,
};

/**
 * Helper to get inactivity configuration in different units
 */
export const getInactivityConfig = () => ({
    timeoutMs: INACTIVITY_CONFIG.TIMEOUT_MS,
    timeoutMinutes: INACTIVITY_CONFIG.TIMEOUT_MS / (1000 * 60),
    checkIntervalMs: INACTIVITY_CONFIG.CHECK_INTERVAL_MS,
    checkIntervalSeconds: INACTIVITY_CONFIG.CHECK_INTERVAL_MS / 1000,
});
